/**
 * Root reducer.
 * @module reducers/root
 */

import { locationsReducer } from './locations/locations';
import { locationsManagerReducer } from './locationsManager/locationsManager';
import { locationReducer } from './location/location';
import { recaptchaReducer } from './recaptcha/recaptcha';
import { registrationUserschemaReducer } from './registration_userschema/registration_userschema';

/**
 * Root reducer.
 * @function
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export const reducers = {
  locations: locationsReducer,
  locationsManager: locationsManagerReducer,
  location: locationReducer,
  recaptcha: recaptchaReducer,
  registration_userschema: registrationUserschemaReducer,
};
